
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pos/articles/[articleSlug]",
      function () {
        return require("private-next-pages/pos/articles/[articleSlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pos/articles/[articleSlug]"])
      });
    }
  